import {NgModule} from '@angular/core';
import {
    provideRouter,
    RouterModule,
    withEnabledBlockingInitialNavigation,
    withInMemoryScrolling
} from '@angular/router';
import {ConfigModule, ProtectedRoutesService, RoutingModule} from '@spartacus/core';
import {AppRoutingModule} from '@spartacus/storefront';

import {AimoProtectedRoutesService} from './aimo-protected-routes.service';
import {aimoRoutingConfig} from './aimo-routing.config';
import {AimoRoutePreloadingStrategy} from "./aimo-route-preloading.strategy";

@NgModule({
    providers: [
        {
            provide: ProtectedRoutesService,
            useClass: AimoProtectedRoutesService,
        },
        provideRouter(
            [],
            withInMemoryScrolling()
        ),
    ],
    imports: [
        AppRoutingModule,
        RouterModule.forRoot([], {
            anchorScrolling: 'enabled',
            preloadingStrategy: AimoRoutePreloadingStrategy,
         //   onSameUrlNavigation: 'reload'
        }),
        ConfigModule.withConfig({
            routing: aimoRoutingConfig.routing,
        }),

    ],
})
export class AimoRoutingModule extends RoutingModule {
}
